import styled from "@emotion/styled";
import { useEffect, type HTMLAttributes, type PropsWithChildren } from "react";

import {
  useActivateNodePicking,
  useDeactivateNodePicking,
  useNodePickingActive,
  type NodePickingOptions,
  type ShieldOptions,
  type ToastOptions,
} from "../picking/useNodePicking";

const Container = styled.div``;

export type NodePickingButtonOptions = NodePickingOptions & { shield?: ShieldOptions; toast?: ToastOptions };

type Props = HTMLAttributes<HTMLDivElement> & {
  options: NodePickingButtonOptions;
  onNodePicked?: (nodeId: number) => void;
  onNodesPicked: (nodeIds: number[]) => void;
};

export const NodePickingButton = ({
  options,
  onNodePicked,
  onNodesPicked,
  children,
  ...divAttributes
}: PropsWithChildren<Props>) => {
  const nodePickingActive = useNodePickingActive();
  const deactivateNodePicking = useDeactivateNodePicking();

  const { shield, toast, ...nodePickingOptions } = options;
  const activateNodePicking = useActivateNodePicking(nodePickingOptions);

  const handleClick = () => {
    if (nodePickingActive) return;

    activateNodePicking(onNodePicked, onNodesPicked, { shield, toast });
  };

  useEffect(() => {
    return () => {
      if (nodePickingActive) {
        deactivateNodePicking();
      }
    };
  }, [deactivateNodePicking, nodePickingActive]);

  return (
    <Container onClick={handleClick} {...divAttributes}>
      {children}
    </Container>
  );
};
